import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@/ui';
import { DocumentSection, DocumentSectionList } from '@/features/constructorDocuments';
import { Typography } from 'antd';

export const ConstructorDocuments = () => {
  const { t } = useTranslation();

  return (
    <Container $paddingY={20}>
      <Container $marginBottom={30}>
        <Typography.Title level={3}>{t('Constructor documents')}</Typography.Title>
      </Container>

      <DocumentSectionList />
      <DocumentSection />
    </Container>
  );
};
